const InputsUtils = () => {
    const isValidFirstName = (firstName) => {
        const cond = firstName && firstName.length <= 32 && firstName.length >= 2
        return cond ? 'success' : 'Please enter a valid first name (min. 2 characters, max. 32 characters).'
    }
    
    const isValidLastName = (lastName) => {
        const cond = lastName && lastName.length <= 32 && lastName.length >= 2
        return cond ? 'success' : 'Please enter a valid last name (min. 2 characters, max. 32 characters).'
    }
    
    const isValidCompany = (company) => {
        const cond = company ? company.length <= 32 : true
        return cond ? 'success' : 'Please enter a valid company name (max. 32 characters).'
    }
    
    const isValidCountry = (country) => {
        const cond = country && country.length <= 32 && country.length >= 1
        return cond ? 'success' : 'Please enter a valid country name (min. 1 character, max. 32 characters).'
    }
    
    const isValidUsername = (username) => {
        const cond = username && username.length <= 32 && username.length >= 3
        return cond ? 'success' : 'Please enter a valid username (min. 3 characters, max. 32 characters).'
    }

    const isValidEmail = (email) => {
        const emailRegex = /^(?=.{1,254}$)(?=.{1,64}@)[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,63}$/
        const cond = typeof email === "string" && emailRegex.test(email.trim())

        return cond ? 'success' : 'Please enter a valid email.'
    }

    const invalidPasswordMessage = 'Your password must be between 10 and 32 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character (e.g., !@#$%^&*-).'

    const isValidPasswordRegister = (password) => {
        const condLength = (password && password.length >= 10 && password.length <= 32)
        const condRequiredCharacters = (/[A-Z]/.test(password) && /[a-z]/.test(password) && /[0-9]/.test(password) && /[!@#$%^&*-]/.test(password))
        if (!condLength || !condRequiredCharacters) {
            return invalidPasswordMessage
        }
        return 'success'
    }

    const isValidPasswordLogin = (password) => {
        const cond = password && password.length >= 3 && password.length <= 32
        return cond ? 'success' : 'Please enter a valid password (min. 3 characters, max. 32 characters).'
    }

    const isValidSerialNumber = (serialNumber) => {
        const cond = serialNumber && serialNumber.length === 22
        return cond ? 'success' : 'Please enter a valid serial number (must be 22 characters long).'
    }
    
    return {
        isValidFirstName,
        isValidLastName,
        isValidCompany,
        isValidCountry,
        isValidUsername,
        isValidEmail,
        invalidPasswordMessage,
        isValidPasswordRegister,
        isValidPasswordLogin,
        isValidSerialNumber
    }
}

export default InputsUtils